import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import api from "../../helpers/axios";
import { GET_EMPLOYEE_PROFORMANCE_SUMMARY } from '../../helpers/url_helpers';

const initialState = {
    loading: true,
    data: null
};

export const getPerformanceSummary = createAsyncThunk(
    GET_EMPLOYEE_PROFORMANCE_SUMMARY,
    async (serveyId = null) => {
        const url = serveyId ? GET_EMPLOYEE_PROFORMANCE_SUMMARY + serveyId  : GET_EMPLOYEE_PROFORMANCE_SUMMARY.replace('?survey_id=', '')
        const response = await api.get(url);
        return response.data;
    }
)

const performanceSummarySlice = createSlice({
    name: 'performanceSummary',
    initialState,
    extraReducers: (builder) => {
        builder.addCase(getPerformanceSummary.fulfilled, (state, action) => {
            if(action.payload.data.error) {
                state.data = null;
            } else {
                state.data = action.payload;
                state.loading = false;
            }

        })

        builder.addCase(getPerformanceSummary.pending, (state, action) => {
            state.loading = true;
        })
    }
});

export default performanceSummarySlice.reducer;
